import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { get_application_details, get_single_application, update_application_organization_status } from '../api/applicationsApi';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { permissionCheck } from '../../../helper-functions/PermissionCheck';
var user_application_update;
function ViewApplicationDetails() {
  const [isUpdating, setIsUpdating] = useState(false); // Loading state for mutation
  const location = useLocation();
  const [selectedApplication, setSelectedApplication] = useState<any | null>(null);
  const [viewApplication, setViewApplication] = useState<any[]>([]);
  const navigate=useNavigate();
  const applicationView = (location.state as { application }).application;
  const [status, setStatus] = useState(applicationView?.is_active); // Track application status
  user_application_update = permissionCheck('user-application-update');
  // Fetch Single Application Data
  const { data: applcationDataSingle,isLoading:isLoadingApplcationDataSingle,refetch:refetchaApplcationDataSingle} = useQuery(
    ['get_single_application', applicationView.application_id],
    () => get_single_application(applicationView.application_id),
    {
      refetchOnWindowFocus: false,
    }
  );
  // Update `selectedApplication` when `applcationDataSingle` is fetched
  useEffect(() => {
    if (applcationDataSingle) {
      setSelectedApplication(applcationDataSingle.data);
    }
  }, [applcationDataSingle]);
  // Fetch Application Details only when `selectedApplication` is set
  const { data: applicationViewData, isLoading:isLoadingApplicationViewData, isError, refetch:refetchApplicationViewData } = useQuery(
    ['get_application_details', applicationView.organization_id, applicationView.application_id],
    () =>
      get_application_details(
        applicationView.organization_id,
        applicationView.application_id,
        selectedApplication?.api_url
      ),
    {
      enabled: !!selectedApplication, // Only run query if `selectedApplication` is not null
      refetchOnWindowFocus: true,
    }
  );

  // Update `viewApplication` when `applicationViewData` changes
  useEffect(() => {
    if (applicationViewData) {
      setViewApplication(applicationViewData.data);
    }
  }, [applicationViewData]);

// Handle Update Application Status
const handleUpdateApplicationStatus = async () => {
  try {
    setIsUpdating(true);
    const updatePromises = viewApplication.map(async (tenant) => {
      const response = await update_application_organization_status(
        tenant.organization_id,
        tenant.application_id,
        status
      );

      // Display success toast for each tenant
      toast.success(response.data.message, {
        position: 'top-right',
        autoClose: 3000,
      });
      navigate(-1);
    });

    await Promise.all(updatePromises);
    toast.success('Status updated successfully for all tenants!', {
      position: 'top-right',
      autoClose: 3000,
    });
  } catch (error: any) {
    if (error.response) {
      const errorMessage = error.response.data.message;

      // Display error toast with HTML content
      toast.error(
        <div dangerouslySetInnerHTML={{ __html: errorMessage }} />,
        {
          position: 'top-right',
          autoClose: 6000,
        }
      );
    } else {
      toast.error('An unexpected error occurred. Please try again.', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  } finally {
    setIsUpdating(false);
  }
};
if (isLoadingApplcationDataSingle) {
  return (
    <div className='text-center'>
      <div className='spinner-border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  )
}
if (isLoadingApplicationViewData) {
  return (
    <div className='text-center'>
      <div className='spinner-border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </div>
    </div>
  )
}
  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0'
      >
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>
            {/* Display Organization Name and Application Name */}
            Application Name:{selectedApplication?.name} <span
      className={`fs-3 badge ${
        status ==1 ? 'badge-success' : 'badge-danger'
      } ms-2`}
    >
      {status == 1 ? 'Active' : 'Inactive'}
    </span>
          </span>
        </h3>
        <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                >
                <button
  data-toggle="tooltip" 
  data-placement="bottom" 
  title="Go Back"
  className="btn btn-sm btn-light-dark fs-5"
  onClick={() => navigate(-1)} // Navigate to the previous page
>
  Back to List
</button>
                </div>
      </div>
      <div id='kt_account_profile_details' className='collapse show'>
        <form noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* Tenants Section */}
            {viewApplication.length > 0 ? (
              viewApplication.map((tenant, index) => (
                <div key={tenant.id} className='mb-5'>
              <div className='border border-primary rounded p-3 px-5 m-6'>
                     <div className='row mb-3'>
                     <label className='col-lg-4 col-form-label fw-bold fs-6'>
            Organization Name
            </label>
            <div className='col-lg-8'>
                        <input
                          type='text'
                          className='form-control form-control-solid mb-2'
                          value={tenant.name}
                          readOnly
                        />
                    </div>
            </div>
                 {/* Frontend Domains */}
<div className='row mb-3'>
  <label className='col-lg-4 col-form-label fw-bold fs-6'>
    Frontend Domains
  </label>
  <div className='col-lg-8'>
    {tenant.frontend_domain.map((frontendDomain, i) => (
      <div key={i} className='mb-2'>
        <label className='form-label fw-bold'>
          Frontend Domain {i + 1}
        </label>
        <input
          type='text'
          className='form-control form-control-solid'
          value={frontendDomain}
          readOnly
        />
      </div>
    ))}
  </div>
</div>
               {/* Domain Names */}
<div className='row mb-3'>
  <label className='col-lg-4 col-form-label fw-bold fs-6'>
    API Domains
  </label>
  <div className='col-lg-8'>
    {tenant.domain_name.map((domain, i) => (
      <div key={i} className='mb-2'>
        <label className='form-label fw-bold'>
          API Domain {i + 1}
        </label>
        <input
          type='text'
          className='form-control form-control-solid'
          value={domain}
          readOnly
        />
      </div>
    ))}
  </div>
</div>
</div>
                  {/* IP Addresses */}
                  <div className='border border-danger rounded p-3 px-5 m-6'>
                  <div className='row mb-3'>
                    <label className='col-lg-4 col-form-label fw-bold fs-6'>
                      IP Addresses
                    </label>
                    <div className='col-lg-8'>
                      {tenant.ip_address.map((ip, i) => (
                        <input
                          key={i}
                          type='text'
                          className='form-control form-control-solid mb-2'
                          value={ip}
                          readOnly
                        />
                      ))}
                    </div>
                  </div>
                  {/* Status Toggle */}
      <div className='row mb-3'>
        <label className='col-lg-4 col-form-label fw-bold fs-6'>
          Status
        </label>
        <div className='col-lg-8'>
          <select
            className='form-select form-select-solid mb-2'
            value={status} // Display current status
            onChange={(e) =>
              setStatus(e.target.value) // Update status when changed
            }
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>
      </div>
      </div>
                </div>
              ))
            ) : (
              <p>No tenants available.</p>
            )}
          </div>
          {
            user_application_update && (
              <div className="card-footer d-flex justify-content-end">
            <button
              type="button"
              className={`btn btn-primary ${
                isUpdating ? 'disabled' : ''
              }`}
              onClick={handleUpdateApplicationStatus}
              disabled={isUpdating}
            >
              {isUpdating ? 'Updating...' : 'Update Status'}
            </button>
          </div>
            )
          }
        </form>
      </div>
    </div>
  );
}

export default ViewApplicationDetails;
